export default { SOURCE: 'pwa'};
